import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, Button, message } from 'antd';

export const VideoAdGroupForm = ({
  visible,
  setVisible,
  selectedAdGroup,
  updateAdGroup,
  allAdGroups = [],
}) => {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);


  useEffect(() => {
    if (selectedAdGroup) {
      form.setFieldsValue({
        name: selectedAdGroup.name,
        creatives: selectedAdGroup.medias.map((media) => media.id),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAdGroup]);

  const validateUniqueName = (_, value) => {
    if (!value) return Promise.resolve();

    const lowerValue = value.toLowerCase().trim();
    const currentName = selectedAdGroup?.name?.toLowerCase().trim();

    if (lowerValue === currentName) return Promise.resolve();

    const isDuplicate = allAdGroups.some(
      group => group.name.toLowerCase().trim() === lowerValue && group.id !== selectedAdGroup?.id
    );

    if (isDuplicate) {
      return Promise.reject(new Error("Video ad group name already exists"));
    }

    return Promise.resolve();
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const onFinish = async (values) => {
    try {
      setIsSubmitting(true);

      const mediasToDisconnect = selectedAdGroup.medias
        .map((media) => media.id)
        .filter((mediaId) => !values.creatives.includes(mediaId));

      await updateAdGroup({
        adGroup: {
          name: values.name,
          medias: mediasToDisconnect,
          id: selectedAdGroup.id,
        },
        type: 'disconnect',
      });

      message.success('Video ad group updated successfully');
      setVisible(false);
    } catch (error) {
      console.error('Error updating video ad group:', error);
      message.error('Failed to update video ad group');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOk = () => {
    form.submit();
  };

  return (
    <div>
      <Modal
        title="Edit Video Ad Group"
        visible={visible}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel} disabled={isSubmitting}>
            Cancel
          </Button>,
          <Button type="primary" onClick={handleOk} loading={isSubmitting} disabled={isSubmitting}>
            Submit
          </Button>,
        ]}
      >
        <Form form={form} onFinish={onFinish}>
          <Form.Item
            label="Name (Max 255 characters)"
            name="name"
            rules={[
              {
                required: true,
                message: "Please enter a video ad group name",
              },
              {
                max: 255,
                message: "Video ad group name must not exceed 255 characters",
              },
              {
                validator: validateUniqueName,
              },
            ]}
          >
            <Input maxLength={255} showCount />
          </Form.Item>
          <Form.Item
            label="Videos"
            name="creatives"
            rules={[
              {
                required: true,
                message: 'Please select at least one video',
              },
            ]}
          >
            <Select
              mode="multiple"
              showSearch={false}
              options={selectedAdGroup?.medias?.map((media) => ({
                value: media.id,
                label: media.name,
              })) || []}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
